import TechHero from "../components/TechHero";
import { CONTACT_INFO } from "../config/constants";

export default function TermsConditions() {
  return (
    <div className="space-y-8 pb-16">
      <TechHero
        kicker="Legal"
        title="Terms & Conditions"
        subtitle="Please read these terms carefully before using our website"
      />

      <section className="max-w-4xl mx-auto space-y-6 text-white/90">
        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">1. Agreement to Terms</h2>
          <p>
            By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">2. Use License</h2>
          <p className="mb-3">Permission is granted to temporarily download one copy of the materials (information or software) on our website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose or for any public display</li>
            <li>Attempt to decompile or reverse engineer any software</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
            <li>Transfer the materials to another person or "mirror" the materials on any other server</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">3. Disclaimer</h2>
          <p>
            The materials on our website are provided for informational purposes only. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">4. Limitations of Liability</h2>
          <p>
            In no event shall ZS NEXATECH or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on our website, even if we or our authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">5. Accuracy of Materials</h2>
          <p>
            The materials appearing on our website could include technical, typographical, or photographic errors. We do not warrant that any of the materials on our website are accurate, complete, or current. We may make changes to the materials contained on our website at any time without notice.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">6. Links</h2>
          <p>
            We have not reviewed all of the sites linked to our website and are not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by us of the site. Use of any such linked website is at the user's own risk.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">7. Modifications</h2>
          <p>
            We may revise these terms of service for our website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of India, and you irrevocably submit to the exclusive jurisdiction of the courts in Ahmedabad, Gujarat.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">9. User Content</h2>
          <p>
            You retain all rights to any content you submit, post, or display on or through our website. By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, and distribute such content.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">10. Prohibited Conduct</h2>
          <p className="mb-3">You agree not to:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>Harass, threaten, or abuse other users</li>
            <li>Post or transmit any content that violates laws or regulations</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Transmit viruses or malicious code</li>
            <li>Engage in any form of spamming or phishing</li>
            <li>Violate any intellectual property rights</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">11. Project Work & Deliverables</h2>
          <p className="mb-3">For any project work:</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>Project scope and deliverables will be defined in a separate project agreement</li>
            <li>Payment terms will be as specified in the project contract</li>
            <li>Intellectual property rights will be transferred upon full payment</li>
            <li>We reserve the right to use completed projects in our portfolio</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-amber-400 mb-3">12. Contact Information</h2>
          <p>
            If you have any questions about these Terms & Conditions, please contact us at:
          </p>
          <p className="mt-3 font-semibold">
            Email: {CONTACT_INFO.email}<br />
            Phone: {CONTACT_INFO.phone}
          </p>
        </div>

        <div className="pt-4 border-t border-white/20">
          <p className="text-sm text-white/60">
            Last Updated: February 2026. These terms are subject to change without notice.
          </p>
        </div>
      </section>
    </div>
  );
}
